var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pp",on:{"click":_vm.print}},[_c('img',{staticClass:"pimg",attrs:{"src":require("@/assets/img/print.png"),"alt":""}}),_vm._v("打印 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }